/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { ToastsHandlerBase } from "si-mfes-library/toasts/handler/toasts-handler-base";
import { ToastModel } from "si-mfes-library/toasts/toast.model";
import sanitizeHtml from "sanitize-html";
export class ToastsService extends ToastsHandlerBase {
  private readonly parentNode: Element;

  constructor(window: Window, parentNodeSelector: any) {
    super(window);
    this.parentNode = document.querySelector(parentNodeSelector);
  }

  protected uiCloseToast(toast: ToastModel): void {
    const toastHtml = document.querySelector(`div[toast-id='${toast.id}']`);
    if (toastHtml) {
      toastHtml.classList.add("hide");
      toastHtml.parentNode.removeChild(toastHtml);

      toastHtml.addEventListener("animationend", () => {
        toastHtml.parentNode.removeChild(toastHtml);
      });
    }
  }

  protected uiOpenToast(toast: ToastModel): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    const toastHtmlContent = `
      <div class="toast-content">
        <div class="icon"><clr-icon shape="${sanitizeHtml(
          toast.severity
        )}" size="24"></clr-icon></div>
        <div class="message">${sanitizeHtml(toast.text)}</div>
      </div>
      <div class="dismiss"><clr-icon size="24" shape="window-close"></clr-icon></div>`;

    const toastElement = document.createElement("div");
    toastElement.setAttributeNS(null, "class", "toaster");
    if (toast.severity) {
      toastElement.classList.add(toast.severity);
    }
    toastElement.setAttributeNS(null, "toast-id", toast.id);
    toastElement.innerHTML = toastHtmlContent;
    const dismissButton = toastElement.querySelector(".dismiss");

    if (dismissButton) {
      dismissButton.addEventListener(
        "click",
        (event: Event) => {
          event.preventDefault();
          const toastElement = dismissButton.closest(".toaster");
          if (!toastElement) {
            return;
          }
          const toastId = toastElement.getAttribute("toast-id");
          if (toastId) {
            self.closeToastById(toastId);
          }
        },
        false
      );
    }
    const toastContent = toastElement.querySelector(".toast-content");
    if (!!toastContent && !!toast.clickAction) {
      toastElement.classList.add("pointer");
      toastContent.addEventListener(
        "click",
        (event: Event) => {
          event.preventDefault();
          const parentNode = dismissButton.closest(".toaster");
          if (!parentNode) {
            return;
          }
          const toastId = toastElement.getAttribute("toast-id");
          if (toastId) {
            const clickableToast = self.getToastById(toastId);
            if (clickableToast) {
              self.clickToast(clickableToast);
            }
          }
        },
        false
      );
    }
    this.parentNode.insertAdjacentElement("beforeend", toastElement);
  }

  private closeToastById(toastId: string): void {
    const toast = this.getToastById(toastId);
    if (toast) {
      this.closeToast(toast, false);
    }
  }
}
